import React, {useCallback} from "react";
import { useIntl } from "react-intl";
import { TextField } from "@material-ui/core";
import type { FC, ChangeEvent } from "react";
import { useInputStyles } from "./Search.styles";
import { messages } from './Search.messages';
import SearhIcon from "../../../../../../../../../icons/SearchBlack";
import type { ISearchProps } from "./Search.types";

export const Search: FC<ISearchProps> = (props) => {
  const intl = useIntl();
  const classesInput = useInputStyles();
  const {onChange} = props;
  const handleChange = useCallback((e: ChangeEvent<HTMLInputElement>) => {
    onChange?.(e.target.value);
  }, [onChange]);

  const placeholder = intl.formatMessage(messages.searchPlaceholder);

  return (
    <TextField
      onChange={handleChange}
      placeholder={placeholder}
      InputProps={{
        startAdornment: <SearhIcon className={classesInput.adornedEnd} />,
        classes: { ...classesInput, adornedEnd: undefined },
      }}
    />
  );
};
